export const actions = {
    toggleIsSidebarActive({commit}, val) {
        commit('TOGGLE_IS_SIDEBAR_ACTIVE', !!val);
    },
    updateWindowBreakpoint({commit}, val) {
        commit('UPDATE_WINDOW_BREAKPOINT', val);
    },
    updateSidebarItemsMin({commit}, val) {
        commit('UPDATE_SIDEBAR_ITEMS_MIN', val);
    },
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },
    login({commit}, {authToken, user}) {
        commit('UPDATE_TOKEN', authToken);
        commit('UPDATE_USER', user);
    },
    logout({commit}) {
        commit('UPDATE_TOKEN', null);
        commit('UPDATE_USER', {});
    },
    updateDateRange({commit}, payload) {
        commit('UPDATE_DATE_RANGE', payload)
    },
    loadUsers({commit}, usuarios) {
        commit('UPDATE_USERS', usuarios)
    },
    addReq({commit}, payload) {
        commit('ADD_TOKEN', payload)
    },
    remReq({commit}, key) {
        commit('REM_TOKEN', key)
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },
    updateUser({commit}, user) {
        commit('UPDATE_USER', user);
    },
};
